import axios from "axios"
import { handleError } from "../Helpers/ErrorHandler"
import { UserProfileToken } from "../Models/User";
import { MTB_PART_PICKER_API } from "../constants";

export const loginAPI = async (email: string, password: string) => {
    try {
        const data = await axios.post<UserProfileToken>(MTB_PART_PICKER_API + "/Account/login", {
            email: email,
            password: password
        })
        return data;
    } catch (error) {
        handleError(error)
    }
};

export const registerAPI = async (email: string, username: string, password: string) => {
    try {
        const data = await axios.post<UserProfileToken>(MTB_PART_PICKER_API + "/Account/register", {
            email: email,
            username: username,
            password: password
        })
        return data;
    } catch (error) {
        handleError(error)
    }
};

export const updateProfileAPI = async (id: string, username: string, email: string, first_name: string, 
                                        last_name: string, rider_type: string, location: string, profile_pic_url: string) => {
    try {
        const data = await axios.put<UserProfileToken>(MTB_PART_PICKER_API + "/Account/updateProfile", {
            id: id,
            email: email,
            username: username,
            first_name: first_name,
            last_name: last_name,
            rider_type: rider_type,
            location: location,
            profile_pic_url: profile_pic_url
        })
        return data;
    } catch (error) {
        handleError(error)
    }
};